var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { useHistory, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Accordion, Checkbox, Pane, PaneFooter, Button, TextField, Select, Headline, Row, Col, Loading, ConfirmationModal, MessageBanner, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { createUserSchema } from "../utils/validationUtils";
import { useModal } from "../utils/useModal";
import { PASSWORD_INPUT_TYPE, NEW_PASSWORD_AUTOCOMPLETE, } from "../utils/passwordInputProps";
import PasswordRulesHint from "../components/PasswordRulesHint";
import { usePermissions } from "../utils/permissionsUtils";
import { getErrorInfo, isOptimisticLockConflict, } from "../utils/getErrorCode";
import { GENERIC_USER_ERROR_ID, getUserErrorMessageId, } from "../utils/getErrorMessageId";
import { fetchOrganizations } from "../api/organizationService";
import useNavigation from "../hooks/useNavigation";
import { diffRoles, inverseMutation, } from "../utils/rolesUtils";
import { EDITABLE_GLOBAL_ROLES, FIXED_GLOBAL_ROLES, authorityTypeLabel, splitAuthorityTypes, withAssignedTypes, } from "../utils/authorityTypes";
import useAuthorityTypes from "../hooks/useAuthorityTypes";
import WelcomeEmailFailedModal from "../components/WelcomeEmailFailedModal";
import { NK_ROLES, NON_STANDARD, isNkRole, assignmentFormValue, classifyAssignment, describeNonStandard, nkRoleMessageId, rowsOfType, } from "../utils/nkRoles";
import { addGlobalRole, removeGlobalRole, addAuthorityTypeRole, updateAuthorityTypeRole, removeAuthorityTypeRole, } from "../api/userService";
import ActionErrorModal from "../components/ActionErrorModal";
/**
 * Who may hand out each editable global role (US-02 business rule):
 * AUTHORITY_ADMIN is admin-only. CZNA-1635 removed the user and vocabulary
 * administrator roles, so it is the only editable global role left.
 *
 * CZNA-474: an exhaustive `Record` over EDITABLE_GLOBAL_ROLES, so a global role
 * added to that list (the third supervisor level, say) fails to compile until
 * its gate is declared here — rather than rendering with an accidental default,
 * or being silently left out of the screen as the authority types were.
 */
var GLOBAL_ROLE_ASSIGNABLE_BY = {
    AUTHORITY_ADMIN: "AUTHORITY_ADMIN",
};
export var ROLE_SAVE_ERROR_CODE = "ROLE_SAVE_ERROR";
/**
 * Thrown when one or more role mutations fail after the main user PUT succeeds.
 * Carries the list of failed operation types so the error modal can display them, and the
 * message ids of the reasons the backend gave that the screen knows how to explain
 * (CZNA-1604: a role scoped to an organization archived meanwhile).
 */
var RoleSaveError = /** @class */ (function (_super) {
    __extends(RoleSaveError, _super);
    function RoleSaveError(errorList, reasonMessageIds) {
        if (reasonMessageIds === void 0) { reasonMessageIds = []; }
        var _this = _super.call(this, "Role save partial failure") || this;
        /** Brand. Not the prototype chain — see {@link isRoleSaveError}. */
        _this.code = ROLE_SAVE_ERROR_CODE;
        _this.errorList = errorList;
        _this.reasonMessageIds = reasonMessageIds;
        _this.name = "RoleSaveError";
        return _this;
    }
    return RoleSaveError;
}(Error));
export { RoleSaveError };
/**
 * Type guard for the mutation's `onError`. **Brand check, deliberately not `instanceof`**
 * — CZNA-686.
 *
 * <p>`.tsx` files are compiled by ts-loader against `stripes-webpack`'s own tsconfig,
 * which sets no `target`, so the ES5 default applies and this class ships as
 * `wn.call(this, "Role save partial failure") || this` — verified verbatim in the deployed
 * bundle, where the constructed object's prototype is `Error.prototype` and
 * `instanceof RoleSaveError` is false. `name` and `errorList` are both set, so nothing
 * looks wrong in the console. Under jest the same expression is true. The mechanism and
 * its evidence live in `ui-czna-authorities/src/customErrorInstanceofGate.test.ts`, which
 * also fails on any new occurrence in either module.
 *
 * <p>What it cost on this screen: a partial role failure took the generic branch instead.
 * The user saw an anonymous save error rather than the list of role operations that
 * failed, and `originalUserRef` was never reset — so a retry re-issued the mutations that
 * had already succeeded.
 */
export var isRoleSaveError = function (error) {
    return typeof error === "object" &&
        error !== null &&
        error.code === ROLE_SAVE_ERROR_CODE &&
        "errorList" in error;
};
export var ROLE_REVERT_ERROR_CODE = "ROLE_REVERT_ERROR";
export var roleRevertError = function (notReverted, conflict) {
    if (conflict === void 0) { conflict = false; }
    return Object.assign(new Error("Role revert failure"), {
        name: "RoleRevertError",
        code: ROLE_REVERT_ERROR_CODE,
        notReverted: notReverted,
        conflict: conflict,
    });
};
export var ROLE_STALE_CODE = "ROLE_STALE";
export var roleStaleError = function (notReverted, afterSave) {
    if (notReverted === void 0) { notReverted = ""; }
    return Object.assign(new Error("Role write refused as stale"), {
        name: "RoleStaleError",
        code: ROLE_STALE_CODE,
        notReverted: notReverted,
        afterSave: afterSave,
    });
};
/** Brand check, never `instanceof` — see {@link isRoleSaveError} (CZNA-686). */
export var isRoleStaleError = function (error) {
    return typeof error === "object" &&
        error !== null &&
        error.code === ROLE_STALE_CODE;
};
/** Brand check, never `instanceof` — the reason is on {@link isRoleSaveError} (CZNA-686). */
export var isRoleRevertError = function (error) {
    return typeof error === "object" &&
        error !== null &&
        error.code === ROLE_REVERT_ERROR_CODE &&
        "notReverted" in error;
};
export var ROLE_SAVE_ABORTED_CODE = "ROLE_SAVE_ABORTED";
export var roleSaveAbortedError = function (failed, notReverted) {
    return Object.assign(new Error("Role save aborted"), {
        name: "RoleSaveAbortedError",
        code: ROLE_SAVE_ABORTED_CODE,
        failed: failed,
        notReverted: notReverted,
    });
};
/** Brand check, never `instanceof` — see {@link isRoleSaveError} (CZNA-686). */
export var isRoleSaveAbortedError = function (error) {
    return typeof error === "object" &&
        error !== null &&
        error.code === ROLE_SAVE_ABORTED_CODE &&
        "failed" in error;
};
/** How a role change is put in words — see `describeChange` in the form. */
var CHANGE_MESSAGE_IDS = {
    stillInEffect: {
        globalAdd: "ui-czna-users.users.roles.revert.globalAdded",
        globalRemove: "ui-czna-users.users.roles.revert.globalRemoved",
        add: "ui-czna-users.users.roles.revert.added",
        change: "ui-czna-users.users.roles.revert.changed",
        remove: "ui-czna-users.users.roles.revert.removed",
    },
    attempted: {
        globalAdd: "ui-czna-users.users.roles.change.globalAdd",
        globalRemove: "ui-czna-users.users.roles.change.globalRemove",
        add: "ui-czna-users.users.roles.change.add",
        change: "ui-czna-users.users.roles.change.change",
        remove: "ui-czna-users.users.roles.change.remove",
    },
};
/**
 * The reasons of failed role calls the screen has a message for, each once (CZNA-1604).
 *
 * <p>Only reasons with their own message: a failure the mapping can only call generic adds
 * nothing to the partial-failure text, which already says which operations failed.
 */
var explainedRoleFailures = function (failureInfos) {
    // Infos read once by the caller: a response body can be read only once.
    var ids = failureInfos.map(function (info) { return getUserErrorMessageId(info); });
    // indexOf, not a spread Set: ts-loader ships this file as ES5 (see isRoleSaveError), where a
    // spread Set without downlevelIteration is not the array it is under jest.
    return ids.filter(function (id, index) { return id !== GENERIC_USER_ERROR_ID && ids.indexOf(id) === index; });
};
/**
 * Keeps a stored organization id selectable even when the option list does not offer it.
 *
 * <p>Both organization selects on this screen are filled from one query — the ACTIVE
 * organizations, capped at 500 rows. A stored id can be missing from that list: the
 * organization was archived since (a soft delete, with nothing stopping an organization
 * that is referenced from being deactivated), or it fell past the cap. A `<select>` whose
 * value matches no option has no selected option, so the browser's "ask for a reset"
 * step selects the FIRST one instead — and the two lists disagree about what that first
 * option means, which is why both callers need this and neither is cosmetic:
 *
 * <ul>
 *   <li>role scope (CZNA-577, until CZNA-1598 removed the scope select): the first option
 *       was "Celostátně", so the screen claimed national reach for a role narrowed to a
 *       single library.</li>
 *   <li>user organization (CZNA-607): the first option is the "vyberte organizaci"
 *       placeholder, so the screen shows the user as belonging nowhere.</li>
 * </ul>
 *
 * <p>Appending the unresolvable id as its own option keeps the display honest and, more
 * importantly, keeps the value RECOVERABLE. Hence both values, not just the current one:
 * derived from the current value alone the extra option vanishes the moment the admin
 * picks something else — which the empty-looking required field invites — and the stored
 * organization can then never be put back. Keeping the STORED id listed for the whole edit
 * makes that trip reversible. The label is the raw id, the same way the detail pane prints
 * it; resolving the archived organization's name would need a second query and is
 * deliberately left out of scope.
 *
 * <p>What this does NOT do is unblock saving. Measured on the edit form (CZNA-607): the
 * form state still holds the stored id, so submitting an untouched form already sent the
 * correct `organizationId` and raised no validation error. The defect is the misreport and
 * the one-way trip it invites, not a save that fails.
 */
var withUnresolvableValues = function (options) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    var missing = values.filter(function (value, i) {
        return Boolean(value) &&
            values.indexOf(value) === i &&
            !options.some(function (o) { return o.value === value; });
    });
    return missing.length
        ? __spreadArray(__spreadArray([], options, true), missing.map(function (value) { return ({ value: value, label: value }); }), true) : options;
};
/** Shallow copy of `obj` without `keys` — a rest-destructure whose omitted siblings stay unused. */
var omitKeys = function (obj, keys) {
    var copy = __assign({}, obj);
    keys.forEach(function (key) { return delete copy[key]; });
    return copy;
};
var UserFormContent = function (_a) {
    var _b, _c;
    var match = _a.match, serverAuthorityTypes = _a.serverAuthorityTypes;
    var id = useParams().id;
    var goToList = useNavigation(match.path).goToList;
    var history = useHistory();
    var intl = useIntl();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var _d = useModal(), isOpen = _d.isOpen, message = _d.message, openModal = _d.openModal, closeModal = _d.closeModal;
    /** CZNA-1603: the save was refused because somebody else saved this user meanwhile. */
    var _e = useState(false), showConflictModal = _e[0], setShowConflictModal = _e[1];
    /**
     * The form has no server baseline to save against (its version, its roles) — while the
     * user is re-loaded after a partial role failure, or when that load failed. Save stays
     * disabled: a PUT without the version is refused (400), and a role diff against a stale
     * baseline would repeat calls that already landed.
     */
    var _f = useState(false), awaitingBaseline = _f[0], setAwaitingBaseline = _f[1];
    var isEditing = Boolean(id);
    /**
     * CZNA-1598: which organizations are NK, by id — read by the schema at validation time, so
     * the schema itself does not have to be rebuilt (and the resolver swapped) when the
     * organization list arrives. `undefined` for an organization the list does not hold.
     */
    var nationalLibraryRef = useRef(new Map());
    var schema = useMemo(function () {
        return createUserSchema(intl, {
            isNationalLibrary: function (organizationId) {
                return nationalLibraryRef.current.get(organizationId);
            },
        });
    }, [intl]);
    var _g = usePermissions(), canEditUser = _g.canEditUser, isAuthorityAdmin = _g.isAuthorityAdmin;
    // Stores the original user data at form load time so diffRoles can compute what changed
    var originalUserRef = useRef(undefined);
    /**
     * CZNA-1589: the user this save created although its welcome e-mail failed. Set by the
     * mutation function, which knows it right after the POST, and read by `onSuccess`/`onError`
     * — a ref, because those callbacks would see a state value from before the save.
     */
    var welcomeEmailFailedRef = useRef(undefined);
    /**
     * CZNA-1598 review: the user this save created. react-query hands `onError` the options of
     * the render that started the save — the CREATE render, with no id — so the new user is
     * passed on here, for the baseline a retry of its failed role calls stands on.
     */
    var createdUserRef = useRef(undefined);
    /** The warning on screen, and where the admin goes once done with it. */
    var _h = useState(undefined), welcomeEmailWarning = _h[0], setWelcomeEmailWarning = _h[1];
    /**
     * Turns a pending e-mail failure into the warning. `leaveForList` is where this save would
     * have ended without it: the list on success, the form after a partial role failure (which
     * keeps the admin there to retry the roles).
     */
    var showWelcomeEmailWarning = function (leaveForList) {
        var failure = welcomeEmailFailedRef.current;
        welcomeEmailFailedRef.current = undefined;
        if (!failure)
            return false;
        setWelcomeEmailWarning(__assign(__assign({}, failure), { leaveForList: leaveForList }));
        return true;
    };
    var handleWelcomeEmailWarningDone = function () {
        var leaveForList = welcomeEmailWarning === null || welcomeEmailWarning === void 0 ? void 0 : welcomeEmailWarning.leaveForList;
        setWelcomeEmailWarning(undefined);
        if (leaveForList)
            goToList();
    };
    var _j = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            globalRoles: {
                AUTHORITY_ADMIN: false,
            },
            // CZNA-474/CZNA-650: one "" per type the server offers, so a rendered select never
            // lacks a default value — and the form is not dirty the moment it mounts.
            authorityTypeRoles: Object.fromEntries((serverAuthorityTypes !== null && serverAuthorityTypes !== void 0 ? serverAuthorityTypes : []).map(function (type) { return [type.code, ""]; })),
        },
        mode: "onBlur",
        shouldFocusError: false,
    }), handleSubmit = _j.handleSubmit, control = _j.control, reset = _j.reset, setValue = _j.setValue, watch = _j.watch, _k = _j.formState, errors = _k.errors, isSubmitting = _k.isSubmitting, isDirty = _k.isDirty;
    var _l = useQuery(["czna-users", "user", id], function () { return ky.get("czna-users/users/".concat(id)).json(); }, { enabled: isEditing }), user = _l.data, userLoading = _l.isLoading, refetchUser = _l.refetch;
    // Same query (and cache entry) as UserDetailPane's self-archive guard.
    var _m = useQuery(["czna-users", "me"], function () { return ky.get("czna-users/users/me").json(); }, {
        enabled: isEditing,
        staleTime: 5 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
    }), currentUser = _m.data, currentUserLoading = _m.isLoading;
    /**
     * US-03 A3 (CZNA-1587): nobody may change their own roles — global or per authority type,
     * adding, editing or removing. The backend refuses every role call on the caller's own
     * account with 403; here the role controls are read-only with a banner saying why, and the
     * save sends no role call at all, so editing one's own name or contacts still succeeds.
     * Only an edit can be "own": a user being created is never the caller.
     */
    var isSelf = isEditing && Boolean(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === id;
    /**
     * Fails CLOSED (CZNA-1587 review): when the "me" query failed or answered without an id,
     * the form cannot tell whether this is the caller's own account. Treating that as "someone
     * else" would offer the very controls US-03 A3 forbids, so the roles are locked exactly as
     * on the own account, with their own explanation. The backend still decides; this only keeps
     * the screen from offering — and the save from sending — role changes it cannot vouch for.
     * Create mode never asks (the query is disabled), and a new user is never the caller.
     *
     * <p>Decided on the DATA, not on `isError`: a failed first load leaves no data and so locks,
     * but a failed background refetch (window focus) keeps the identity react-query already
     * holds — and an id does not change. Locking on `isError` there would freeze the controls
     * mid-edit on someone else's account and make the save silently drop role changes the admin
     * had already made.
     */
    var identityUnknown = isEditing && !currentUserLoading && !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    /** Role controls read-only and no role call on save — see `isSelf` and `identityUnknown`. */
    var rolesLocked = isSelf || identityUnknown;
    var organizations = useQuery(["czna-organizations", "active"], function () { return fetchOrganizations(ky, { query: 'status=="ACTIVE"', limit: 500 }); }).data;
    nationalLibraryRef.current = new Map(((_b = organizations === null || organizations === void 0 ? void 0 : organizations.items) !== null && _b !== void 0 ? _b : []).map(function (org) { return [
        org.id,
        org.nationalLibrary === true,
    ]; }));
    /**
     * The types this form renders and diffs: the server list plus every type the user already
     * holds — see {@link withAssignedTypes}. When the list failed to load that is the held
     * types alone, so existing grants stay editable while nothing new can be offered.
     */
    var authorityTypesFor = useCallback(function (forUser) {
        var _a, _b;
        return withAssignedTypes(serverAuthorityTypes !== null && serverAuthorityTypes !== void 0 ? serverAuthorityTypes : [], (_b = (_a = forUser === null || forUser === void 0 ? void 0 : forUser.authorityTypeRoles) === null || _a === void 0 ? void 0 : _a.map(function (r) { return r.authorityType; })) !== null && _b !== void 0 ? _b : []);
    }, [serverAuthorityTypes]);
    var renderedAuthorityTypes = useMemo(function () { return authorityTypesFor(user); }, [authorityTypesFor, user]);
    var renderedAuthorityTypeCodes = useMemo(function () { return renderedAuthorityTypes.map(function (type) { return type.code; }); }, [renderedAuthorityTypes]);
    /** The role values of the form a stored user reads as. */
    var roleFormValues = useCallback(function (stored) {
        var _a, _b;
        return ({
            globalRoles: {
                AUTHORITY_ADMIN: (_b = (_a = stored.roles) === null || _a === void 0 ? void 0 : _a.some(function (r) { return r.role === "AUTHORITY_ADMIN"; })) !== null && _b !== void 0 ? _b : false,
            },
            // CZNA-1598: the NK role the server reads the type's rows as, or the
            // non-standard sentinel — see `classifyAssignment`.
            authorityTypeRoles: Object.fromEntries(authorityTypesFor(stored).map(function (type) { return [
                type.code,
                assignmentFormValue(classifyAssignment(rowsOfType(stored.authorityTypeRoles, type.code))),
            ]; })),
        });
    }, [authorityTypesFor]);
    /**
     * Makes `serverUser` the form's baseline: the values on screen, the roles diffRoles compares
     * against on save (`originalUserRef`) and the version the save sends (CZNA-1603).
     */
    var captureServerUser = useCallback(function (serverUser) {
        originalUserRef.current = serverUser;
        setAwaitingBaseline(false);
        reset(__assign(__assign({}, serverUser), roleFormValues(serverUser)));
    }, [roleFormValues, reset]);
    /**
     * Puts the admin's submitted role choices back over a freshly captured baseline, marked as
     * changed (CZNA-1598 review) — field by field, the names the role controls are registered
     * under: a whole-object setValue right after reset() does not reach them.
     */
    var keepRoleChoices = function (submitted) {
        EDITABLE_GLOBAL_ROLES.forEach(function (role) {
            setValue("globalRoles.".concat(role), submitted.globalRoles[role], {
                shouldDirty: true,
            });
        });
        Object.entries(submitted.authorityTypeRoles).forEach(function (_a) {
            var type = _a[0], value = _a[1];
            setValue("authorityTypeRoles.".concat(type), value, { shouldDirty: true });
        });
    };
    /**
     * CZNA-1598 review: role choices of a save that created the user and could not make all
     * of its role calls. They wait for the new user's baseline — whichever load delivers it
     * first: the form's own GET after the failure, or the edit route's query — and are put back
     * on top of it exactly once.
     */
    var pendingRoleChoicesRef = useRef(undefined);
    var applyPendingRoleChoices = function () {
        var pending = pendingRoleChoicesRef.current;
        pendingRoleChoicesRef.current = undefined;
        if (pending)
            keepRoleChoices(pending);
    };
    /** The form stands on a loaded user with this id — a baseline a save can use. */
    var hasBaselineFor = function (userId) {
        var _a, _b;
        return Boolean(userId) &&
            ((_a = originalUserRef.current) === null || _a === void 0 ? void 0 : _a.id) === userId &&
            ((_b = originalUserRef.current) === null || _b === void 0 ? void 0 : _b.version) !== undefined;
    };
    useEffect(function () {
        if (user && !originalUserRef.current) {
            // Capture original user data and initialize form only once (on initial load).
            // Subsequent refetches (e.g. refetchOnWindowFocus) must not overwrite in-progress edits.
            captureServerUser(user);
            // A new user's unsaved role choices, when this is the load that delivers it.
            applyPendingRoleChoices();
        }
        // applyPendingRoleChoices only reads a ref and calls setValue.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, captureServerUser]);
    /**
     * CZNA-1603 "Načíst znovu": loads the user as the server holds it now — fields, roles and
     * version — and makes it the form's baseline, so the next save neither overwrites the other
     * admin's change nor re-sends role calls the server already reflects. Captured here rather
     * than left to the effect above: that one runs only when the query's data changes identity,
     * which a refetch answering an equal object does not do.
     */
    var handleConflictReload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, errorInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowConflictModal(false);
                    return [4 /*yield*/, refetchUser()];
                case 1:
                    result = _a.sent();
                    if (!(result.isSuccess && result.data)) return [3 /*break*/, 2];
                    captureServerUser(result.data);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, getErrorInfo(result.error)];
                case 3:
                    errorInfo = _a.sent();
                    openModal(intl.formatMessage({ id: getUserErrorMessageId(errorInfo) }));
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * CZNA-1598: the user PUT did NOT go through, yet some role calls before it could not be
     * undone — the stored roles differ from the baseline while the stored user does not.
     * Takes the ROLES from the server (baseline and role controls, so a retry does not repeat
     * calls that landed) but keeps the baseline's OLD version and the fields the admin typed:
     * adopting the server's version would let a retry overwrite whatever another admin saved
     * meanwhile. Save stays off until the roles are known; if they cannot be loaded the
     * baseline is dropped, and the form reloads as a whole once the user loads again.
     */
    var refreshRoleBaselineKeepingVersion = function () { return __awaiter(void 0, void 0, void 0, function () {
        var old, result, roles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    old = originalUserRef.current;
                    setAwaitingBaseline(true);
                    return [4 /*yield*/, refetchUser()];
                case 1:
                    result = _a.sent();
                    if (!result.isSuccess || !result.data) {
                        originalUserRef.current = undefined;
                        return [2 /*return*/, false];
                    }
                    originalUserRef.current = __assign(__assign({}, result.data), { version: old === null || old === void 0 ? void 0 : old.version });
                    roles = roleFormValues(result.data);
                    setValue("globalRoles", roles.globalRoles, { shouldDirty: true });
                    setValue("authorityTypeRoles", roles.authorityTypeRoles, { shouldDirty: true });
                    setAwaitingBaseline(false);
                    return [2 /*return*/, true];
            }
        });
    }); };
    /**
     * One role call. `userVersion` is the user version the call stands on (CZNA-1598 review):
     * the server refuses it with 409 OPTIMISTIC_LOCK when the user changed since, before
     * writing anything. Undefined only when there is no version to send.
     */
    var runRoleMutation = function (userId, m, userVersion) {
        switch (m.type) {
            case "addGlobal":
                return addGlobalRole(ky, userId, m.role, m.validFrom || m.validTo
                    ? __assign(__assign({}, (m.validFrom ? { validFrom: m.validFrom } : {})), (m.validTo ? { validTo: m.validTo } : {})) : undefined, userVersion);
            case "removeGlobal":
                return removeGlobalRole(ky, userId, m.role, userVersion);
            case "addAuthorityType":
                // CZNA-1598: the NK role alone — the server derives role and organization.
                return addAuthorityTypeRole(ky, userId, __assign(__assign({ authorityType: m.authorityType, nkRole: m.nkRole }, (m.validFrom ? { validFrom: m.validFrom } : {})), (m.validTo ? { validTo: m.validTo } : {})), userVersion);
            case "updateAuthorityType":
                // The PUT replaces the whole assignment, so the stored validity window has to
                // ride along — omitting it would null validFrom/validTo, and an expiring role
                // silently becoming permanent is a widening, not a cosmetic loss.
                return updateAuthorityTypeRole(ky, userId, m.roleId, {
                    authorityType: m.authorityType,
                    nkRole: m.nkRole,
                    validFrom: m.validFrom,
                    validTo: m.validTo,
                }, userVersion);
            case "removeAuthorityType":
                return removeAuthorityTypeRole(ky, userId, m.roleId, userVersion);
            default: {
                var unhandled = m;
                throw new Error("Unhandled mutation type: ".concat(unhandled.type));
            }
        }
    };
    /**
     * Runs the role mutations in two rounds: every removal, then everything else. CZNA-1598:
     * the server refuses a role write while another row exists for the same authority type,
     * so replacing a non-standard type only works once its rows are gone. Within a round the
     * calls run in parallel and all of them are attempted (`allSettled`); a failure anywhere
     * still lets the other round run, and every failed operation is reported together.
     * `executed`, when given, collects every call that went through with its answer, in the
     * order they were sent — what an undo walks back.
     *
     * <p>A call refused with 409 OPTIMISTIC_LOCK means the form is stale (CZNA-1598 review):
     * no further round runs and a {@link RoleStaleError} is thrown — the caller decides what to
     * undo. Every call carries `userVersion`.
     */
    var executeRoleMutations = function (userId, mutations, userVersion, executed, failed) { return __awaiter(void 0, void 0, void 0, function () {
        var isRemoval, rounds, failedTypes, failureInfos, _loop_1, _i, rounds_1, round;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (mutations.length === 0)
                        return [2 /*return*/];
                    isRemoval = function (m) {
                        return m.type === "removeGlobal" || m.type === "removeAuthorityType";
                    };
                    rounds = [
                        mutations.filter(isRemoval),
                        mutations.filter(function (m) { return !isRemoval(m); }),
                    ];
                    failedTypes = [];
                    failureInfos = [];
                    _loop_1 = function (round) {
                        var results, infos, stale;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, Promise.allSettled(round.map(function (m) { return runRoleMutation(userId, m, userVersion); }))];
                                case 1:
                                    results = _b.sent();
                                    return [4 /*yield*/, Promise.all(results.map(function (r) {
                                            return r.status === "rejected" ? getErrorInfo(r.reason) : undefined;
                                        }))];
                                case 2:
                                    infos = _b.sent();
                                    stale = false;
                                    results.forEach(function (r, i) {
                                        var _a;
                                        if (r.status === "rejected") {
                                            failedTypes.push(round[i].type);
                                            failed === null || failed === void 0 ? void 0 : failed.push(round[i]);
                                            var info = (_a = infos[i]) !== null && _a !== void 0 ? _a : {};
                                            failureInfos.push(info);
                                            if (isOptimisticLockConflict(info))
                                                stale = true;
                                        }
                                        else
                                            executed === null || executed === void 0 ? void 0 : executed.push({ mutation: round[i], result: r.value });
                                    });
                                    if (stale)
                                        throw roleStaleError();
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, rounds_1 = rounds;
                    _a.label = 1;
                case 1:
                    if (!(_i < rounds_1.length)) return [3 /*break*/, 4];
                    round = rounds_1[_i];
                    return [5 /*yield**/, _loop_1(round)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    if (failedTypes.length > 0) {
                        throw new RoleSaveError(failedTypes.join(", "), explainedRoleFailures(failureInfos));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var authorityTypeName = function (code) {
        var type = renderedAuthorityTypes.find(function (t) { return t.code === code; });
        return type ? authorityTypeLabel(intl, type) : code;
    };
    /**
     * One role change in words: as one still in effect after a failed undo (`stillInEffect`),
     * or as one that was attempted and failed (`attempted`). Literal ids per phrasing, so the
     * translation gate can resolve every one of them.
     */
    var describeChange = function (m, baselineRows, phrasing) {
        var _a;
        var ids = CHANGE_MESSAGE_IDS[phrasing];
        switch (m.type) {
            case "addGlobal":
            case "removeGlobal":
                return intl.formatMessage({ id: m.type === "addGlobal" ? ids.globalAdd : ids.globalRemove }, { role: intl.formatMessage({ id: "ui-czna-users.role.".concat(m.role) }) });
            case "addAuthorityType":
            case "updateAuthorityType":
                return intl.formatMessage({ id: m.type === "addAuthorityType" ? ids.add : ids.change }, {
                    authorityType: authorityTypeName(m.authorityType),
                    role: intl.formatMessage({ id: nkRoleMessageId(m.nkRole) }),
                });
            default: {
                var row = baselineRows === null || baselineRows === void 0 ? void 0 : baselineRows.find(function (r) { return r.id === m.roleId; });
                var role = isNkRole(row === null || row === void 0 ? void 0 : row.nkRole)
                    ? intl.formatMessage({ id: nkRoleMessageId(row.nkRole) })
                    : intl.formatMessage({
                        id: "ui-czna-users.authorityTypeRole.".concat((row === null || row === void 0 ? void 0 : row.role) === "CATALOGER" ? "CATALOGER" : "CATALOGING_SUPERVISOR"),
                    });
                return intl.formatMessage({ id: ids.remove }, { authorityType: authorityTypeName((_a = row === null || row === void 0 ? void 0 : row.authorityType) !== null && _a !== void 0 ? _a : ""), role: role });
            }
        }
    };
    /**
     * Undoes role calls that went through, newest first, one at a time — the newest are the
     * adds, and a type's add has to be gone before its removed row can come back (the server
     * refuses a second row for a type). Returns the changes that are still in effect: those the
     * API cannot put back (see `inverseMutation`) and those whose undo failed.
     */
    var revertRoleMutations = function (userId, executed, baseline, userVersion) { return __awaiter(void 0, void 0, void 0, function () {
        var stillInEffect, _i, _a, _b, mutation, result, undo, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    stillInEffect = [];
                    _i = 0, _a = __spreadArray([], executed, true).reverse();
                    _d.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    _b = _a[_i], mutation = _b.mutation, result = _b.result;
                    undo = inverseMutation(mutation, result, baseline);
                    if (!!undo) return [3 /*break*/, 2];
                    stillInEffect.push(mutation);
                    return [3 /*break*/, 5];
                case 2:
                    _d.trys.push([2, 4, , 5]);
                    // One at a time on purpose — see above.
                    // eslint-disable-next-line no-await-in-loop
                    return [4 /*yield*/, runRoleMutation(userId, undo, userVersion)];
                case 3:
                    // One at a time on purpose — see above.
                    // eslint-disable-next-line no-await-in-loop
                    _d.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _c = _d.sent();
                    stillInEffect.push(mutation);
                    return [3 /*break*/, 5];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, stillInEffect];
            }
        });
    }); };
    /**
     * Role calls AFTER the user itself was saved (PUT or POST). A call refused as stale stops
     * them (see executeRoleMutations); nothing is undone — another admin changed the user
     * meanwhile — and the error names what of this save went through (`savedBefore` plus the
     * calls here that completed) and what did not.
     */
    var runRoleCallsAfterSave = function (userId_1, mutations_1, userVersion_1, baselineRows_1) {
        var args_1 = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            args_1[_i - 4] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([userId_1, mutations_1, userVersion_1, baselineRows_1], args_1, true), void 0, function (userId, mutations, userVersion, baselineRows, savedBefore) {
            var executed, error_1, done_1, describe_1;
            if (savedBefore === void 0) { savedBefore = []; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        executed = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, executeRoleMutations(userId, mutations, userVersion, executed)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (!isRoleStaleError(error_1))
                            throw error_1;
                        done_1 = executed.map(function (e) { return e.mutation; });
                        describe_1 = function (list) {
                            return list.map(function (m) { return describeChange(m, baselineRows, "attempted"); }).join("; ");
                        };
                        throw roleStaleError("", {
                            saved: describe_1(__spreadArray(__spreadArray([], savedBefore, true), done_1, true)),
                            notSaved: describe_1(mutations.filter(function (m) { return !done_1.includes(m); })),
                        });
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var saveMutation = useMutation(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var userData_1, version_1, putUser, mutations, savedVersion_1, grantsNkSupervisor_1, beforeMove, baseline_1, baselineRows_1, executed_1, failed, notRevertedText, error_2, _a, _b, _c, savedVersion, error_3, notReverted, _d, _e, _f, globalRoles, authorityTypeRoles, password, temporaryPassword, rest, userData, createRequest, createdUser, basePath, mutations;
        var _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    welcomeEmailFailedRef.current = undefined;
                    createdUserRef.current = undefined;
                    if (!isEditing) return [3 /*break*/, 21];
                    if (!id)
                        throw new Error("User ID is required for editing");
                    // Never a PUT without the version the form stands on — see `awaitingBaseline`.
                    if (((_g = originalUserRef.current) === null || _g === void 0 ? void 0 : _g.version) === undefined) {
                        throw new Error("The user's current state is not loaded");
                    }
                    userData_1 = omitKeys(values, ["globalRoles", "authorityTypeRoles"]);
                    version_1 = (_h = originalUserRef.current) === null || _h === void 0 ? void 0 : _h.version;
                    putUser = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var request, saved, _a, savedVersion;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    request = ky.put("czna-users/users/".concat(id), {
                                        json: __assign(__assign({}, userData_1), { version: version_1 }),
                                    });
                                    if (!(typeof (request === null || request === void 0 ? void 0 : request.json) === "function")) return [3 /*break*/, 2];
                                    return [4 /*yield*/, request.json()];
                                case 1:
                                    _a = _b.sent();
                                    return [3 /*break*/, 4];
                                case 2: return [4 /*yield*/, request];
                                case 3:
                                    _a = _b.sent();
                                    _b.label = 4;
                                case 4:
                                    saved = _a;
                                    savedVersion = saved === null || saved === void 0 ? void 0 : saved.version;
                                    return [2 /*return*/, typeof savedVersion === "number" ? savedVersion : undefined];
                            }
                        });
                    }); };
                    if (!rolesLocked) return [3 /*break*/, 2];
                    return [4 /*yield*/, putUser()];
                case 1:
                    _o.sent();
                    return [2 /*return*/];
                case 2:
                    mutations = diffRoles((_j = originalUserRef.current) === null || _j === void 0 ? void 0 : _j.roles, (_k = originalUserRef.current) === null || _k === void 0 ? void 0 : _k.authorityTypeRoles, values.globalRoles, values.authorityTypeRoles, renderedAuthorityTypeCodes);
                    if (!(values.organizationId === ((_l = originalUserRef.current) === null || _l === void 0 ? void 0 : _l.organizationId))) return [3 /*break*/, 5];
                    return [4 /*yield*/, putUser()];
                case 3:
                    savedVersion_1 = _o.sent();
                    return [4 /*yield*/, runRoleCallsAfterSave(id, mutations, savedVersion_1, (_m = originalUserRef.current) === null || _m === void 0 ? void 0 : _m.authorityTypeRoles)];
                case 4:
                    _o.sent();
                    return [2 /*return*/];
                case 5:
                    grantsNkSupervisor_1 = function (m) {
                        return (m.type === "addAuthorityType" || m.type === "updateAuthorityType") &&
                            m.nkRole === "NK_SUPERVISOR";
                    };
                    beforeMove = mutations.filter(function (m) { return !grantsNkSupervisor_1(m); });
                    baseline_1 = originalUserRef.current;
                    baselineRows_1 = baseline_1 === null || baseline_1 === void 0 ? void 0 : baseline_1.authorityTypeRoles;
                    executed_1 = [];
                    failed = [];
                    notRevertedText = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, revertRoleMutations(id, executed_1, baseline_1, version_1)];
                                case 1: return [2 /*return*/, (_a.sent())
                                        .map(function (m) { return describeChange(m, baselineRows_1, "stillInEffect"); })
                                        .join("; ")];
                            }
                        });
                    }); };
                    _o.label = 6;
                case 6:
                    _o.trys.push([6, 8, , 12]);
                    return [4 /*yield*/, executeRoleMutations(id, beforeMove, version_1, executed_1, failed)];
                case 7:
                    _o.sent();
                    return [3 /*break*/, 12];
                case 8:
                    error_2 = _o.sent();
                    if (!isRoleStaleError(error_2)) return [3 /*break*/, 10];
                    _a = roleStaleError;
                    return [4 /*yield*/, notRevertedText()];
                case 9: throw _a.apply(void 0, [_o.sent()]);
                case 10:
                    if (!isRoleSaveError(error_2))
                        throw error_2;
                    _b = roleSaveAbortedError;
                    _c = [failed.map(function (m) { return describeChange(m, baselineRows_1, "attempted"); }).join("; ")];
                    return [4 /*yield*/, notRevertedText()];
                case 11: 
                // Some of these calls failed. Moving the user with the roles half rewritten would
                // most likely be refused, or leave a state nobody asked for: the PUT is not sent,
                // and the calls of this batch that went through are undone, so the save as a whole
                // did not happen.
                throw _b.apply(void 0, _c.concat([_o.sent()]));
                case 12:
                    savedVersion = void 0;
                    _o.label = 13;
                case 13:
                    _o.trys.push([13, 15, , 19]);
                    return [4 /*yield*/, putUser()];
                case 14:
                    savedVersion = _o.sent();
                    return [3 /*break*/, 19];
                case 15:
                    error_3 = _o.sent();
                    return [4 /*yield*/, notRevertedText()];
                case 16:
                    notReverted = _o.sent();
                    if (!notReverted) return [3 /*break*/, 18];
                    _d = roleRevertError;
                    _e = [notReverted];
                    _f = isOptimisticLockConflict;
                    return [4 /*yield*/, getErrorInfo(error_3)];
                case 17: throw _d.apply(void 0, _e.concat([_f.apply(void 0, [_o.sent()])]));
                case 18: throw error_3;
                case 19: return [4 /*yield*/, runRoleCallsAfterSave(id, mutations.filter(grantsNkSupervisor_1), savedVersion, baselineRows_1, executed_1.map(function (e) { return e.mutation; }))];
                case 20:
                    _o.sent();
                    return [3 /*break*/, 24];
                case 21:
                    globalRoles = values.globalRoles, authorityTypeRoles = values.authorityTypeRoles, password = values.password, temporaryPassword = values.temporaryPassword, rest = __rest(values, ["globalRoles", "authorityTypeRoles", "password", "temporaryPassword"]);
                    userData = omitKeys(rest, ["passwordConfirm"]);
                    createRequest = password
                        ? { user: userData, password: password, temporaryPassword: temporaryPassword }
                        : { user: userData };
                    return [4 /*yield*/, ky
                            .post("czna-users/users", { json: createRequest })
                            .json()];
                case 22:
                    createdUser = _o.sent();
                    // CZNA-1589: created, but the password setup link never went out. Only `false`
                    // means that — absent is a user created with a password, where no e-mail is sent.
                    if (createdUser.welcomeEmailSent === false) {
                        welcomeEmailFailedRef.current = {
                            userId: createdUser.id,
                            email: createdUser.email,
                        };
                    }
                    basePath = match.path.replace("/create", "");
                    history.replace("".concat(basePath, "/").concat(createdUser.id, "/edit"));
                    mutations = diffRoles(undefined, undefined, globalRoles, authorityTypeRoles, renderedAuthorityTypeCodes);
                    createdUserRef.current = createdUser;
                    // The role calls stand on the version the POST answered for the new user.
                    return [4 /*yield*/, runRoleCallsAfterSave(createdUser.id, mutations, typeof createdUser.version === "number" ? createdUser.version : undefined, undefined)];
                case 23:
                    // The role calls stand on the version the POST answered for the new user.
                    _o.sent();
                    _o.label = 24;
                case 24: return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            queryClient.invalidateQueries(["czna-users"]);
            // The warning leads to the list itself once the admin is done with it.
            if (!showWelcomeEmailWarning(true))
                goToList();
        },
        onError: function (error, submitted) { return __awaiter(void 0, void 0, void 0, function () {
            var created, partialError, result, created, fresh, _a, errorInfo;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(isRoleStaleError(error) && error.afterSave)) return [3 /*break*/, 1];
                        // The user was saved, then a role call was refused as stale: what went through
                        // and what did not, in the error modal; then "Načíst znovu" (the conflict dialog
                        // waits for the modal) — one message per dialog, CZNA-1603's dialog unchanged. The
                        // admin's choices stay in the form. No fresh baseline is taken here: the server
                        // holds someone else's change too, and adopting its version silently would let the
                        // next save overwrite it.
                        openModal(intl.formatMessage({ id: "ui-czna-users.users.roles.staleAfterSaveReload" }, {
                            saved: error.afterSave.saved ||
                                intl.formatMessage({ id: "ui-czna-users.nkRole.none" }),
                            notSaved: error.afterSave.notSaved,
                        }));
                        created = createdUserRef.current;
                        if (created && submitted) {
                            // Created just now: the new user, as the POST answered it, is the baseline — its
                            // version is the one this save stood on — with the admin's choices kept. A
                            // baseline the edit route's query already captured is kept as it is.
                            pendingRoleChoicesRef.current = submitted;
                            if (!hasBaselineFor(created.id))
                                captureServerUser(created);
                            applyPendingRoleChoices();
                        }
                        setShowConflictModal(true);
                        return [3 /*break*/, 17];
                    case 1:
                        if (!isRoleStaleError(error)) return [3 /*break*/, 2];
                        // A role call was refused as stale: the plan stopped, and what of it could not be
                        // undone is named first. Then "Načíst znovu" — the form's state is outdated.
                        if (error.notReverted) {
                            openModal(intl.formatMessage({ id: "ui-czna-users.users.roles.revert.failed" }, { changes: error.notReverted }));
                        }
                        setShowConflictModal(true);
                        return [3 /*break*/, 17];
                    case 2:
                        if (!isRoleSaveAbortedError(error)) return [3 /*break*/, 5];
                        openModal(intl.formatMessage({
                            id: error.notReverted
                                ? "ui-czna-users.users.roles.preMove.failedNotReverted"
                                : "ui-czna-users.users.roles.preMove.failed",
                        }, { failed: error.failed, changes: error.notReverted }));
                        if (!error.notReverted) return [3 /*break*/, 4];
                        return [4 /*yield*/, refreshRoleBaselineKeepingVersion()];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4: return [3 /*break*/, 17];
                    case 5:
                        if (!isRoleRevertError(error)) return [3 /*break*/, 7];
                        openModal(intl.formatMessage({ id: "ui-czna-users.users.roles.revert.failed" }, { changes: error.notReverted }));
                        return [4 /*yield*/, refreshRoleBaselineKeepingVersion()];
                    case 6:
                        _c.sent();
                        // A stale form stays stale: once the message is closed, offer "Načíst znovu".
                        if (error.conflict)
                            setShowConflictModal(true);
                        return [3 /*break*/, 17];
                    case 7:
                        if (!isRoleSaveError(error)) return [3 /*break*/, 15];
                        partialError = __spreadArray([
                            intl.formatMessage({ id: "ui-czna-users.users.roles.save.partialError" }, { errors: error.errorList })
                        ], ((_b = error.reasonMessageIds) !== null && _b !== void 0 ? _b : []).map(function (id) {
                            return intl.formatMessage({ id: id });
                        }), true).join(" ");
                        openModal(partialError);
                        queryClient.invalidateQueries(["czna-users"]);
                        if (!isEditing) return [3 /*break*/, 9];
                        // Re-capture fresh server state before a retry is possible: the profile PUT moved
                        // the version on and some role calls landed, so the old baseline would send a
                        // stale version and repeat those calls. Loaded and captured HERE, not left to the
                        // capture effect: react-query hands back the same object when the user's data did
                        // not change, and that effect would then never run (DB-281 verify).
                        setAwaitingBaseline(true);
                        return [4 /*yield*/, refetchUser()];
                    case 8:
                        result = _c.sent();
                        if (result.isSuccess && result.data) {
                            captureServerUser(result.data);
                            // CZNA-1598 review: the server's user is the new baseline (version, the roles
                            // that landed), but the admin's choices stay on screen and the form stays
                            // dirty — so Save diffs them against that baseline and retries exactly the
                            // calls that failed, instead of the failed choice silently disappearing.
                            if (submitted)
                                keepRoleChoices(submitted);
                        }
                        else {
                            // No baseline to retry on; the effect re-captures once the user loads again.
                            originalUserRef.current = undefined;
                            openModal("".concat(partialError, " ").concat(intl.formatMessage({
                                id: "ui-czna-users.error.loadFailed",
                            })));
                        }
                        return [3 /*break*/, 14];
                    case 9:
                        created = createdUserRef.current;
                        pendingRoleChoicesRef.current = submitted;
                        fresh = void 0;
                        if (!(created === null || created === void 0 ? void 0 : created.id)) return [3 /*break*/, 13];
                        setAwaitingBaseline(true);
                        _c.label = 10;
                    case 10:
                        _c.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, ky.get("czna-users/users/".concat(created.id)).json()];
                    case 11:
                        fresh = _c.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        _a = _c.sent();
                        fresh = undefined;
                        return [3 /*break*/, 13];
                    case 13:
                        if (fresh && !pendingRoleChoicesRef.current && hasBaselineFor(fresh.id)) {
                            // The route's query got there first and the choices are on screen already:
                            // only the baseline the diff stands on takes the fresher load, the form stays.
                            originalUserRef.current = fresh;
                            setAwaitingBaseline(false);
                        }
                        else if (fresh) {
                            captureServerUser(fresh);
                            applyPendingRoleChoices();
                        }
                        else if (hasBaselineFor(created === null || created === void 0 ? void 0 : created.id)) {
                            // The route's query delivered the user meanwhile: stand on it.
                            setAwaitingBaseline(false);
                            applyPendingRoleChoices();
                        }
                        else {
                            // Nothing loaded yet: the capture effect takes the user once the route's query
                            // loads it, and applies the choices then. Save stays off until it does.
                            originalUserRef.current = undefined;
                        }
                        _c.label = 14;
                    case 14: return [3 /*break*/, 17];
                    case 15: return [4 /*yield*/, getErrorInfo(error)];
                    case 16:
                        errorInfo = _c.sent();
                        if (isOptimisticLockConflict(errorInfo)) {
                            // CZNA-1603: stale form — offer to load the current state instead of an error.
                            setShowConflictModal(true);
                        }
                        else {
                            openModal(intl.formatMessage({ id: getUserErrorMessageId(errorInfo) }));
                        }
                        _c.label = 17;
                    case 17:
                        // The user exists even though something after the POST failed — the e-mail warning
                        // still applies, and follows the error once that is closed (see the render).
                        showWelcomeEmailWarning(false);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleClose = function () {
        goToList();
    };
    /**
     * CZNA-1598 review — one save at a time. A save is a plan (role calls, the user PUT, maybe
     * an undo), and `mutate` returns at once, so react-hook-form's `isSubmitting` is false again
     * before the plan has even started; a second click would run the whole plan again against a
     * baseline the first run is changing. The ref closes the gap between two submits in one
     * render; the button follows the mutation's own loading state.
     */
    var saveInFlightRef = useRef(false);
    var onSubmit = function (values) {
        if (saveInFlightRef.current)
            return;
        saveInFlightRef.current = true;
        saveMutation.mutate(values, {
            onSettled: function () {
                saveInFlightRef.current = false;
            },
        });
    };
    /**
     * CZNA-1598: the organization picked in the form right now — Supervizor NK is offered only
     * when it is NK. `watch`, not `useWatch`: on react-hook-form 7.54 a `useWatch` subscription
     * does not re-render for values that arrive via the `reset()` above (measured in CZNA-577).
     */
    var watchedOrganizationId = watch("organizationId");
    var organizationIsNationalLibrary = nationalLibraryRef.current.get(watchedOrganizationId) === true;
    var organizationNameById = useMemo(function () { var _a; return new Map(((_a = organizations === null || organizations === void 0 ? void 0 : organizations.items) !== null && _a !== void 0 ? _a : []).map(function (org) { return [org.id, org.name]; })); }, [organizations]);
    /**
     * The options of one type's select: none and the NK roles, plus
     * <ul>
     *   <li>Supervizor NK only for a user of NK — or while this type holds it (stored or
     *       picked), so switching the user to another library does not silently drop it; the
     *       schema then blocks the save until another role is picked;</li>
     *   <li>for a non-standard type, its own option naming the stored rows, pre-selected:
     *       leaving it selected leaves the rows untouched (see `diffRoles`).</li>
     * </ul>
     */
    var roleOptionsFor = function (type, currentValue) {
        var stored = classifyAssignment(rowsOfType(user === null || user === void 0 ? void 0 : user.authorityTypeRoles, type));
        var keepNkSupervisor = organizationIsNationalLibrary ||
            currentValue === "NK_SUPERVISOR" ||
            (stored.kind === "standard" && stored.nkRole === "NK_SUPERVISOR");
        return __spreadArray(__spreadArray([
            {
                value: "",
                label: intl.formatMessage({ id: "ui-czna-users.nkRole.none" }),
            }
        ], NK_ROLES.filter(function (role) { return role !== "NK_SUPERVISOR" || keepNkSupervisor; }).map(function (role) { return ({
            value: role,
            label: intl.formatMessage({ id: nkRoleMessageId(role) }),
        }); }), true), (stored.kind === "nonStandard"
            ? [
                {
                    value: NON_STANDARD,
                    label: describeNonStandard(intl, stored.rows, function (orgId) {
                        return organizationNameById.get(orgId);
                    }),
                },
            ]
            : []), true);
    };
    var roleErrors = errors.authorityTypeRoles;
    var nkSupervisorBlocked = Object.values(roleErrors !== null && roleErrors !== void 0 ? roleErrors : {}).some(function (error) { return error === null || error === void 0 ? void 0 : error.message; });
    var organizationOptions = useMemo(function () {
        var options = [
            {
                value: "",
                label: intl.formatMessage({ id: "ui-czna-users.selectOrganization" }),
            },
        ];
        if (organizations === null || organizations === void 0 ? void 0 : organizations.items) {
            organizations.items.forEach(function (org) {
                options.push({ value: org.id, label: org.name });
            });
        }
        return options;
    }, [intl, organizations]);
    /** CZNA-607 — see {@link withUnresolvableValues}: "" here is the placeholder, not a value. */
    var organizationOptionsFor = function (currentValue) {
        return withUnresolvableValues(organizationOptions, user === null || user === void 0 ? void 0 : user.organizationId, currentValue);
    };
    var _o = splitAuthorityTypes(intl, renderedAuthorityTypes), recordTypes = _o.recordTypes, vocabularyTypes = _o.vocabularyTypes;
    var renderAuthorityTypeRow = function (authorityType) {
        var type = authorityType.code;
        var label = authorityTypeLabel(intl, authorityType);
        return (React.createElement(Row, { key: type },
            React.createElement(Col, { xs: 4 }, label),
            React.createElement(Col, { xs: 8 },
                React.createElement(Controller, { name: "authorityTypeRoles.".concat(type), control: control, render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(Select, __assign({}, field, { disabled: !canEditUser || rolesLocked, "aria-label": intl.formatMessage({
                                id: "ui-czna-users.users.roles.authorityType.roleFor",
                            }, { authorityType: label }), dataOptions: roleOptionsFor(type, field.value), error: (_b = roleErrors === null || roleErrors === void 0 ? void 0 : roleErrors[type]) === null || _b === void 0 ? void 0 : _b.message })));
                    } }))));
    };
    // Waits for "who am I" too: until it is known, own roles would render as editable.
    if (isEditing && (userLoading || currentUserLoading)) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { noValidate: true, onSubmit: handleSubmit(onSubmit) },
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: isEditing ? (React.createElement(FormattedMessage, { id: "ui-czna-users.users.edit" })) : (React.createElement(FormattedMessage, { id: "ui-czna-users.users.new" })), onClose: handleClose, dismissible: true, footer: React.createElement(PaneFooter, { renderEnd: React.createElement(React.Fragment, null,
                        React.createElement(Button, { marginBottom0: true, onClick: handleClose },
                            React.createElement(FormattedMessage, { id: "ui-czna-users.cancel" })),
                        React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, disabled: !isDirty ||
                                isSubmitting ||
                                saveMutation.isLoading ||
                                awaitingBaseline },
                            React.createElement(FormattedMessage, { id: "ui-czna-users.save" }))) }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(Controller, { control: control, name: "firstName", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.firstName" }), error: (_b = errors.firstName) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                            } })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(Controller, { control: control, name: "lastName", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.lastName" }), error: (_b = errors.lastName) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                            } }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(Controller, { control: control, name: "email", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(TextField, __assign({}, field, { 
                                    // @ts-expect-error - stripes TextField supports HTML input types but type definition only allows "text"
                                    type: "email", label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.email" }), error: (_b = errors.email) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                            } })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(Controller, { control: control, name: "phone", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.phone" }), error: (_b = errors.phone) === null || _b === void 0 ? void 0 : _b.message })));
                            } }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(Controller, { control: control, name: "acronym", render: function (_a) {
                                var _b, _c;
                                var field = _a.field;
                                return (React.createElement(TextField, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", maxLength: 20, label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.acronym" }), placeholder: intl.formatMessage({
                                        id: "ui-czna-users.users.acronym.hint",
                                    }), error: (_c = errors.acronym) === null || _c === void 0 ? void 0 : _c.message })));
                            } }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(Controller, { control: control, name: "organizationId", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(Select, __assign({}, field, { dataOptions: organizationOptionsFor(field.value), label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.organization" }), error: (_b = errors.organizationId) === null || _b === void 0 ? void 0 : _b.message })));
                            } }))),
                !isEditing && (React.createElement(React.Fragment, null,
                    React.createElement(Headline, { size: "medium", margin: "large" },
                        React.createElement(FormattedMessage, { id: "ui-czna-users.users.password.section" })),
                    React.createElement("p", { style: { marginTop: 0, color: "#666" } },
                        React.createElement(FormattedMessage, { id: "ui-czna-users.users.password.section.hint" })),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 6 },
                            React.createElement(Controller, { control: control, name: "password", render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (React.createElement(TextField, __assign({}, field, { type: PASSWORD_INPUT_TYPE, autoComplete: NEW_PASSWORD_AUTOCOMPLETE, label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.password" }), error: (_b = errors.password) === null || _b === void 0 ? void 0 : _b.message, "aria-describedby": "create-user-password-rules" })));
                                } })),
                        React.createElement(Col, { xs: 6 },
                            React.createElement(Controller, { control: control, name: "passwordConfirm", render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (React.createElement(TextField, __assign({}, field, { type: PASSWORD_INPUT_TYPE, autoComplete: NEW_PASSWORD_AUTOCOMPLETE, label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.passwordConfirm" }), error: (_b = errors.passwordConfirm) === null || _b === void 0 ? void 0 : _b.message })));
                                } }))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement(PasswordRulesHint, { id: "create-user-password-rules" }))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 6 },
                            React.createElement(Controller, { control: control, name: "temporaryPassword", render: function (_a) {
                                    var _b = _a.field, value = _b.value, onChange = _b.onChange, field = __rest(_b, ["value", "onChange"]);
                                    return (React.createElement(Checkbox, __assign({}, field, { checked: value, onChange: function (e) {
                                            return onChange(e.target.checked);
                                        }, label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.password.temporary" }) })));
                                } }))))),
                isSelf && (React.createElement(MessageBanner, { type: "warning" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.users.roles.selfReadOnly" }))),
                identityUnknown && (React.createElement(MessageBanner, { type: "warning" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.users.roles.identityUnknownReadOnly" }))),
                nkSupervisorBlocked && (React.createElement(MessageBanner, { type: "error" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.users.roles.nkSupervisorBlocked" }))),
                React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.roles.global" }) },
                    FIXED_GLOBAL_ROLES.map(function (role) { return (React.createElement(Checkbox, { key: role, label: React.createElement(FormattedMessage, { id: "ui-czna-users.role.".concat(role) }), checked: true, disabled: true })); }),
                    EDITABLE_GLOBAL_ROLES.map(function (role) { return (React.createElement(Controller, { key: role, name: "globalRoles.".concat(role), control: control, render: function (_a) {
                            var field = _a.field;
                            return (React.createElement(Checkbox, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.role.".concat(role) }), checked: field.value, onChange: function (e) {
                                    return field.onChange(e.target.checked);
                                }, disabled: rolesLocked ||
                                    (GLOBAL_ROLE_ASSIGNABLE_BY[role] === "AUTHORITY_ADMIN"
                                        ? !isAuthorityAdmin
                                        : !canEditUser) }));
                        } })); })),
                React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.roles.authorityType" }) },
                    serverAuthorityTypes === undefined && (React.createElement("p", { role: "alert" },
                        React.createElement(FormattedMessage, { id: "ui-czna-users.users.roles.authorityType.loadError" }))),
                    recordTypes.map(renderAuthorityTypeRow)),
                vocabularyTypes.length > 0 && (React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.roles.vocabularyType" }), closedByDefault: !((_c = user === null || user === void 0 ? void 0 : user.authorityTypeRoles) === null || _c === void 0 ? void 0 : _c.some(function (r) {
                        return vocabularyTypes.some(function (type) { return type.code === r.authorityType; });
                    })) }, vocabularyTypes.map(renderAuthorityTypeRow))))),
        React.createElement(ActionErrorModal, { open: isOpen, message: message, onClose: closeModal }),
        React.createElement(ConfirmationModal, { open: showConflictModal && !isOpen, heading: intl.formatMessage({
                id: "ui-czna-users.error.optimisticLockConflict.heading",
            }), message: intl.formatMessage({
                id: "ui-czna-users.error.optimisticLockConflict.message",
            }), confirmLabel: intl.formatMessage({
                id: "ui-czna-users.error.optimisticLockConflict.reload",
            }), cancelLabel: intl.formatMessage({ id: "ui-czna-users.cancel" }), onConfirm: handleConflictReload, onCancel: function () { return setShowConflictModal(false); } }),
        welcomeEmailWarning && !isOpen && !showConflictModal && (React.createElement(WelcomeEmailFailedModal, { userId: welcomeEmailWarning.userId, email: welcomeEmailWarning.email, onDone: handleWelcomeEmailWarningDone }))));
};
/**
 * CZNA-650: the per-type role selects are built from the server's authority-type list, so the
 * form waits for it before mounting. Not cosmetic: `useForm` reads its default values once, and
 * a select registered later without one would make the form dirty on arrival — or, on edit,
 * miss the `reset()` that loads the user's stored roles.
 *
 * A failed list does not block the form: names, contacts and global roles stay editable, the
 * types the user already holds stay listed, and a message says why nothing new is offered.
 */
var UserForm = function (props) {
    var _a = useAuthorityTypes(), authorityTypes = _a.authorityTypes, isLoading = _a.isLoading, isError = _a.isError;
    if (isLoading) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(UserFormContent, __assign({}, props, { 
        // A refetch that fails after a success keeps the list it had.
        serverAuthorityTypes: authorityTypes !== null && authorityTypes !== void 0 ? authorityTypes : (isError ? undefined : []) })));
};
export default UserForm;
